export const styles = () => ({
  root: {},
  header: {
    height: 38,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "2px solid #009ac9",
    alignItems: "center",
    marginBottom: 10,
  },
  title: {
    fontSize: 16,
    color: "#a1a1a1",
    textAlign: "left",
  },
});
